import { Spin } from "antd";

export default function Spinner(props) {
  const { loading } = props;

  return (
    <div className="spinner-container-styles">
      <Spin tip="Cargando..." spinning={loading} size="large" />
    </div>
  )
}
